import { apm } from "@elastic/apm-rum";
import { Share as ShareIcon, ShareOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { monitor } from "shared/common/services/apm-logging";
import { defaultStore } from "shared/common/stores/defaultStore";
import { sidebarStore } from "shared/common/stores/sidebarStore";
import { generateShareURL } from "shared/common/utils/general-utils";
import PopoverBox from "shared/common/utils/popover/PopoverBox";
import ShareContent from "./ShareContent";

export default function Share({ role }: { role: "edit" | "view" | "api" }) {
  const { t } = useTranslation();

  const viewer = defaultStore((state) => state.viewer);
  const changeAlertMessage = defaultStore((state) => state.changeAlertMessage);

  const sharePopover = sidebarStore((state) => state.sharePopover);
  const changeSharePopover = sidebarStore((state) => state.changeSharePopover);

  //copy url link
  const handleClickShare = () => {
    if (sharePopover) {
      changeSharePopover(false);
      return;
    }
    changeSharePopover(true);
    if (viewer !== undefined) {
      const imageKey = viewer.getScene().getCurrentGeoframe().key;
      const cameraViewString = JSON.stringify(viewer.getCameraView());
      const url = generateShareURL(imageKey, cameraViewString);

      navigator.clipboard.writeText(url.toString());

      changeAlertMessage({
        message: t("share_view.link_copied_message"),
        type: "success",
      });
    }
  };

  return (
    <>
      <Tooltip
        className="onboarding-shareLink"
        title={t("tooltip.share")}
        placement="right"
        enterDelay={400}
        classes={{
          tooltip: "infra3d-buttonDescription",
        }}
      >
        <IconButton
          sx={{
            width: "40px",
            mx: "auto",
            color: "white",
            "@media (hover: hover)": {
              ":hover": { color: "secondary.main" },
            },
          }}
          classes={{
            root: sharePopover
              ? "infra3d-iconButtonRippleActive"
              : "infra3d-iconButtonRipple",
          }}
          onClick={() =>
            monitor(apm, "copied-share-view | Toolbar", () => {
              handleClickShare();
            })
          }
          disableRipple={true}
        >
          {!sharePopover ? (
            <ShareOutlined sx={{ marginLeft: "-2px" }} />
          ) : (
            <ShareIcon sx={{ marginLeft: "-2px" }} />
          )}
        </IconButton>
      </Tooltip>
      <PopoverBox visible={sharePopover}>
        <ShareContent role={role} />
      </PopoverBox>
    </>
  );
}
